// src/reduxStore/modules/tenants/reducer.js

import * as types from './types';

const initialState = {
  tenants: [],
  tenantDetails: null,
  tenantConversations: [],
  currentTenant: null,
  tenantEnableUpload: false,
  userExplicitlyEnabledUpload: false,
  pageInfo: {
    pageNum: 1,
    pageSize: 100,
    sortOrder: 1,
    sortBy: ['FirstName', 'LastName']
  }
};

const tenantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TENANTS:
      return {
        ...state,
        tenants: action.payload
      };
    
    case types.SET_TENANT_DETAILS:
      return {
        ...state,
        tenantDetails: action.payload
      };
    
    case types.SET_TENANT_CONVERSATIONS:
      return {
        ...state,
        tenantConversations: action.payload
      };
    
    case types.SET_CURRENT_TENANT:
      return {
        ...state,
        currentTenant: action.payload
      };
      
    case types.SET_TENANT_ENABLE_UPLOAD:
      // Handle both old and new payload formats for backward compatibility
      const { enabled, isUserAction } = typeof action.payload === 'object'
        ? action.payload
        : { enabled: action.payload, isUserAction: false };

      return {
        ...state,
        tenantEnableUpload: enabled,
        userExplicitlyEnabledUpload: isUserAction ? enabled : state.userExplicitlyEnabledUpload
      };

    case types.SET_USER_EXPLICITLY_ENABLED_UPLOAD:
      return {
        ...state,
        userExplicitlyEnabledUpload: action.payload
      };
    
    case types.ACTION_SET_SORT_ORDER:
      return {
        ...state,
        pageInfo: {
          ...state.pageInfo,
          sortOrder: action.sortOrder
        }
      };
    
    case types.ACTION_SET_SORT_BY:
      return {
        ...state,
        pageInfo: {
          ...state.pageInfo,
          sortBy: action.sortBy
        }
      };
    
    default:
      return state;
  }
};

export default tenantsReducer; 